// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"715":"list","962":"home"}[chunkId] || chunkId) + "." + {"570":"b793795b","715":"72a48967","962":"02409608"}[chunkId] + ".css";
};